import { KeyFacet, numberPart, Key } from './KeyFacet';

export interface IAutoKeyFacetType {
  id: number;
}

/**
 * Variant a of a KeyFacet which provides auto-incrementing identifiers.
 * Instead of .serialize(), use .serializeNext(), which produces a new, unique key on each call.
 */
export class AutoKeyFacet extends KeyFacet<IAutoKeyFacetType> {
  private _lastId: number;

  constructor(name: string) {
    super(name, {
      id: numberPart()
    });

    this._lastId = 0;
  }

  public next(): this['type'] {
    return {
      id: ++this._lastId
    };
  }

  public serializeNext(): Key<this['type']> {
    return this.serialize(this.next());
  }
}
